import { Navigate, Route, Routes } from 'react-router-dom';
import { useAuth } from '../../lib/auth';
import { EngineProvider } from '../../engine/api/context';
import { InspectorProvider } from '../../engine/views/Inspector';
import { Shell } from '../../engine/shell';
import { moduleRoutes } from '../../engine/router';
import { adminModule } from './index';

// Host for the platform-admin surface. A nested EngineProvider hands the engine an admin
// client (prefix /v1/admin) and only the admin module, so every screen reuses the same
// engine (ResourceListScreen / DataGrid / AutoForm / Shell) while its data + meta calls go
// to the service-role /v1/admin route group. Screen paths are relative, so they mount under
// the parent /admin/* route. Access is gated on the platform role (the backend enforces the
// real authz via requirePlatformAdmin — this is only the client-side gate).
export function AdminApp() {
  const { adminClient, principal, signOut } = useAuth();
  if (!principal.platformRole) return <Navigate to="/" replace />;
  return (
    <EngineProvider client={adminClient} modules={[adminModule]} principal={principal} signOut={signOut}>
      <InspectorProvider>
        <Routes>
          <Route element={<Shell brand="Platform Admin" brandShort="PA" />}>
            <Route index element={<Navigate to="tenants" replace />} />
            {moduleRoutes([adminModule])}
            <Route path="*" element={<Navigate to="tenants" replace />} />
          </Route>
        </Routes>
      </InspectorProvider>
    </EngineProvider>
  );
}
